import { createContext, useContext, useState, ReactNode } from 'react';
import { NotificationModal } from '../components/ui/NotificationModal';

interface NotificationState {
  isOpen: boolean;
  title: string;
  message: string | ReactNode;
}

interface NotificationContextType {
  showNotification: (title: string, message: string | ReactNode) => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export function NotificationProvider({ children }: { children: ReactNode }) {
  const [notification, setNotification] = useState<NotificationState>({
    isOpen: false,
    title: '',
    message: '',
  });

  const showNotification = (title: string, message: string | ReactNode) => {
    setNotification({ isOpen: true, title, message });
  };

  const closeNotification = () => {
    setNotification((prev) => ({ ...prev, isOpen: false }));
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <NotificationModal
        isOpen={notification.isOpen}
        onClose={closeNotification}
        title={notification.title}
        message={notification.message}
      />
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
}